import React from "react";

const TopItemsSkeleton = () => {
  return (
    <div className="w-full h-[280px] animate-pulse flex flex-col gap-4 py-4">
      {/* 5 rows */}
      {[1, 2, 3, 4, 5].map((_, i) => (
        <div key={i} className="flex items-center gap-3 px-4">
          {/* Left label */}
          <div className="w-40 h-4 bg-gray-200 rounded"></div>

          {/* Bars container */}
          <div className="flex-1 flex gap-2">
            {/* Stock In bar */}
            <div
              className="bg-gray-200 rounded h-4"
              style={{ width: `${40 + i * 5}%` }}
            ></div>

            {/* Stock Out bar */}
            <div
              className="bg-gray-300 rounded h-4"
              style={{ width: `${20 + i * 4}%` }}
            ></div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default TopItemsSkeleton;
